<template>
  <div class="gallery_detail_container">
    <!-- 详情 -->
    <detail :detail="galleryInfo" v-if="!!galleryInfo"></detail>
    <!-- 底部操作 -->
    <operate :params="detailParams" :id="galleryInfo.id" :contentId="galleryInfo.contentId" :contentTitle="galleryInfo.title" :isCollect="galleryInfo.isCollect" :likeType="galleryInfo.likeType" :allowLikes="galleryInfo.likesSupport" :allow="galleryInfo.allowComment" v-if="!!galleryInfo" @showCommentForm="showCommentForm" @showComments="showComments"></operate>
    <!-- 发布评论 -->
    <submit-comment v-if="!!galleryInfo" :show="isShowCommentForm" :id="galleryInfo.id" :type="galleryInfo.contentType" :parentId="commentParentId" :title="galleryInfo.title" @showCommentForm="showCommentForm"></submit-comment>
    <comment :show="isShowComment" :params="commentParams" @closeComment="closeComments" @replyForm="showCommentReplayForm" v-if="!!galleryInfo"></comment>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount, addScore } from "@/utils";
import galleryApi from "@/api/apis/gallery.js";
import commApi from "@/api/apis/common.js";
import { trackArticleDetailPg } from "@/utils/qt.js";
import detail from "./components/Detail"; //详情
import operate from "./components/Operate"; //底部
import submitComment from "./components/SubmitComment"; //发表评论
import comment from "./components/Comment"; // 评论
export default {
  name: "GalleryDetail",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      /* 是否显示评论表单 */
      isShowCommentForm: false,
      /* 是否显示所有评论的弹层 */
      isShowComment: false,
      commentParentId: "0",
      /* 获取详情所需的参数 */
      detailParams: {
        contentType: null,
        contentId: null,
        fromFlag: null,
        cId: null,
      },
      /* 获取评论列表的参数 */
      commentParams: {
        contentId: null,
        type: null,
      },
      galleryInfo: null, //图集详情
      shareUrl: "",
    };
  },
  components: {
    detail,
    operate,
    submitComment,
    comment,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/gallery_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.galleryInfo.title + " - 法治号客户端", _this.galleryInfo.introduction, _this.shareUrl, _this.galleryInfo.sharePictureUrl);
      }).catch((err) => {

      })
    },
    /* 获取图集详情 */
    getGalleryDetail() {
      var _this = this;
      galleryApi
        .getGalleryDetailById(_this.detailParams)
        .then((res) => {
          if (res.suc == 1) {
            document.title = res.data.title;
            _this.galleryInfo = res.data;
            _this.commentParams.contentId = _this.galleryInfo.id;
            _this.commentParams.type = _this.galleryInfo.contentType;
            _this.wechatShare(); // 微信二次分享
            _this.statistics(); // 统计
            _this.addScore(); // 增加积分
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.galleryInfo.contentCreationTime, // 创建时间
        contentId: this.galleryInfo.id, // 稿件Id
        contentTitle: this.galleryInfo.title,
        contentType: 6,
        memberId: this.galleryInfo.editorId, // 当前稿件的编辑者的id
        nickName: this.galleryInfo.editor, // 当前稿件的编辑者的用户名称
      };
      if (this.detailParams.fromFlag == 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.galleryInfo.channelId, // 栏目id
          channelName: this.galleryInfo.channelName, // 栏目名称
        });
      } else if (this.detailParams.fromFlag == 1) {
        tj_params = Object.assign(tj_params, {
          channelId: this.galleryInfo.specialId, // 专题id
          channelName: this.galleryInfo.specialName, // 专题名称
        });
      } else if (this.detailParams.fromFlag == 2) {
        tj_params = Object.assign(tj_params, {
          channelId: this.galleryInfo.channelJson.id, // 自媒体id
          channelName: this.galleryInfo.channelJson.name, // 自媒体名称
        });
      }
      clickPlayCount(tj_params);
      this.trackArticlePV();
    },
    /* 稿件详情页浏览埋点 */
    trackArticlePV() {
      const extra = {};
      if (this.detailParams.fromFlag == 1) {
        extra.specialName = this.galleryInfo.specialName;
      }
      trackArticleDetailPg(this.galleryInfo, extra);
    },
    /* 增加积分 */
    addScore() {
      let jf_params = {
        code: "lnr", // 必传 (xsgg、fxcg、lnr、tpdcfbcg、gksp、gkyp、zbj、dy、dz、sc)
        description: "浏览内容", // 必传，积分类型描述 (欣赏广告、分享内容、浏览内容、参与投票、观看视频、观看音频、直播间、订阅、点赞、收藏)
        contentType: this.detailParams.contentType, // 非必传，稿件的type
        contentId: this.detailParams.contentId, // 非必传，稿件的id
        contentName: this.galleryInfo.title, // 非必传，稿件的标题
      }
      if (!!this.userInfo) {
        jf_params = Object.assign(jf_params, {
          memberId: this.userInfo.id, //会员id
        });
      }
      addScore(jf_params);
    },
    /* 显示或隐藏评论表单 */
    showCommentForm(data) {
      this.isShowCommentForm = data;
      this.commentParentId = "0";
    },
    /* 评论回复,显示评论表单 */
    showCommentReplayForm(data) {
      this.isShowCommentForm = true;
      this.commentParentId = data;
    },
    /* 显示所有评论 */
    showComments() {
      this.isShowComment = true;
    },
    /* 关闭所有评论 */
    closeComments() {
      this.isShowComment = false;
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.detailParams.contentType = Number(query.contentType) || 6;
      this.detailParams.contentId = Number(query.contentId);
      this.detailParams.fromFlag = Number(query.fromFlag) || 0;
      this.detailParams.cId = Number(query.cId) || 0;
      if (!!this.userInfo) {
        this.detailParams.memberId = this.userInfo.id;
      }
      this.detailParams.shareSign = query.shareSign;
      this.detailParams.timestamp = query.timestamp;
      this.getGalleryDetail();
      loadStat(); // 友盟统计
    }
  },
};
</script>
<style scoped lang="scss">
.gallery_detail_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #000;
  .comment_box {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>